import { Navigate, Route, Routes, useParams } from 'react-router';
import { useMe } from './lib/queries';
import { AppShell } from './components/app/AppShell';
import { lazy, Suspense } from 'react';
import { Landing } from './pages/Landing';
import { Dashboard } from './pages/Dashboard';
import { FeedPage } from './features/feed/FeedPage';

const AiPage = lazy(() => import('./pages/AiPage').then((m) => ({ default: m.AiPage })));

const TABS = ['calendar', 'layers', 'share', 'audience', 'settings', 'history'];

function FeedRoute() {
  const { id = '', tab } = useParams();
  if (tab && !TABS.includes(tab)) return <Navigate to={`/feeds/${id}/${tab === 'sources' ? 'layers' : 'calendar'}`} replace />;
  return <FeedPage id={id} tab={tab ?? 'calendar'} />;
}

export function App() {
  const me = useMe();
  if (me.isPending) return <div className="text-muted-foreground grid h-svh place-items-center text-sm">Loading…</div>;
  if (!me.data) return <Landing />;
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/ai" element={<Suspense fallback={null}><AiPage /></Suspense>} />
        <Route path="/feeds/:id" element={<FeedRoute />} />
        <Route path="/feeds/:id/:tab" element={<FeedRoute />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
